import React from 'react';
import { Link } from 'react-router-dom';
import BrandMark from './BrandMark';
import { SHOW_MARKETPLACE_UI } from '../lib/features';

export default function PublicNav() {
  return (
    <nav className="public-nav">
      <Link to="/" className="public-nav__brand">
        <div className="public-nav__logo">
          <BrandMark size={34} decorative />
        </div>
        <span className="public-nav__brand-text">Transport Team</span>
      </Link>
      <div className="public-nav__actions">
        <Link to="/org/register" className="public-nav__link public-nav__link--muted">
          For organisations
        </Link>
        <Link
          to="/login"
          className={
            SHOW_MARKETPLACE_UI
              ? 'public-nav__link public-nav__link--outline'
              : 'public-nav__link public-nav__link--primary'
          }
        >
          Team sign in
        </Link>
        {SHOW_MARKETPLACE_UI ? (
          <Link to="/book" className="public-nav__link public-nav__link--primary">
            Book a driver
          </Link>
        ) : null}
      </div>
    </nav>
  );
}
